import { ChatProviderType } from '../../domain/chat/models/ChatProviderType';

export const CHAT_MESSAGES_PAGE_SIZE = Number(process.env.REACT_APP_CHAT_MESSAGES_PAGE_SIZE ?? 100);

export const supportsMessagePagination = (providerType: ChatProviderType): boolean =>
    providerType === ChatProviderType.ProGPT || providerType === ChatProviderType.Nexus;
